import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    tabs: {
      margin: spacing(2, 0),
      '& .MuiTabs-indicator': {
        display: 'none',
      },
      '& .Mui-selected': {
        fontWeight: 'bold',
        textDecoration: 'none',
      },
    },
    secondTab: {
      borderLeft: '2px solid #e0e0e0',
    },
    actionBar: {
      padding: '0 .8rem',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& h1': {
        fontWeight: 400,
        width: '20%',
        maxWidth: '18rem',
        minWidth: 'fit-content',
        marginRight: spacing(1),
      },
    },
    main: {
      padding: spacing(3),
    },
    button: {
      width: '14.9rem',
      height: '4.8rem',
    },
    addFolderButton: {
      margin: spacing(0, 0, 0, 2),
    },
    loading: {
      position: 'fixed',
      top: 0,
      left: 0,
      pointerEvents: 'none',
    },
    errorMessage: {
      margin: '5rem 0 0 21rem',
    },
    foldersTable: {
      width: '100%',
    },
  }),
)
